// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3exeo","footer":"ModalInfo_footer__3-5bt"};